import { render, staticRenderFns } from "./chart-finance.vue?vue&type=template&id=2f85316b&"
import script from "./chart-finance.vue?vue&type=script&lang=js&"
export * from "./chart-finance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f85316b')) {
      api.createRecord('2f85316b', component.options)
    } else {
      api.reload('2f85316b', component.options)
    }
    module.hot.accept("./chart-finance.vue?vue&type=template&id=2f85316b&", function () {
      api.rerender('2f85316b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/chart-finance.vue"
export default component.exports